import { Button } from "@mui/material";
import React from "react";
import { convertDateTimeToNet } from "../../../../utils/datetimeUtils";
import { StyledEspecialidadContainer } from "../../../styled/form";
import EspecialidadesAdd from "./especialidadesAdd";
import EspecialidadesCard from "./especialidadesCard";

const especialidadModel = {
  idEspecialidadDiagnosticoOms: null,
  atencion: "",
  turno: null,
  observaciones: "",
};

const EspecialidadesContainer = ({
  especialidades,
  setEspecialidades,
  disabled,
  openAdd,
  setOpenAdd,
  isView,
  idArt,
}) => {
  const handleAdd = (especialidad) => {
    let especialidadExisted = especialidades.find(
      (e) =>
        e.idEspecialidadDiagnosticoOms ===
        especialidad.idEspecialidadDiagnosticoOms,
    );

    if (!especialidadExisted) {
      especialidades.push({
        ...especialidad,
        turno: convertDateTimeToNet(especialidad.turno),
      });
    } else {
      especialidadExisted.turno = convertDateTimeToNet(especialidad.turno);
      especialidadExisted.observaciones = especialidad.observaciones;
    }
    handleCloseAdd();
  };

  const handleDelete = (especialidad) => {
    setEspecialidades(
      especialidades.filter(
        (e) =>
          e.idEspecialidadDiagnosticoOms !==
          especialidad.idEspecialidadDiagnosticoOms,
      ),
    );
  };

  const handleOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
  };

  return (
    <StyledEspecialidadContainer.Container>
      <EspecialidadesCard
        especialidades={especialidades}
        disabled={disabled}
        handleDelete={handleDelete}
      />
      {especialidades.length === 0 && !isView && (
        <StyledEspecialidadContainer.ErrorText variant="body2" color="error">
          Debe agregar una especialidad
        </StyledEspecialidadContainer.ErrorText>
      )}
      <Button
        color="primary"
        variant="outlined"
        onClick={handleOpenAdd}
        disabled={disabled || isView}>
        Agregar especialidad
      </Button>
      <EspecialidadesAdd
        especialidad={especialidadModel}
        open={openAdd}
        handleClose={handleCloseAdd}
        handleSubmit={handleAdd}
        idArt={idArt}
      />
    </StyledEspecialidadContainer.Container>
  );
};

export default EspecialidadesContainer;
